import CircularProgress from "@mui/material/CircularProgress";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { teams } from "actions/teams";
import { linkedInProfileOpener } from "api/linkedInProfileOpener";
import iconLoading from "assets/image/icons/gif/input-loader.gif";

import "./style.scss";

import arrow from "assets/image/icons/svg/arrow-up-right.svg";
import deleteInviteSvg from "assets/image/icons/svg/deleteInvite.svg";
import iconStop from "assets/image/icons/svg/icons/stop.svg";
import threeDots from "assets/image/icons/svg/three-dots.svg";
import avatarSvg from "assets/image/icons/svg/user.svg";
import linkSvgGold from "assets/image/icons/tables/goldLink.svg";
import clsx from "clsx";
import { CONSTS } from "config/objectConst";
import { notificationUtils } from "features/notifications/index.ts";
import { Component } from "react";
import { connect } from "react-redux";
import { notifyError } from "shared/errors/notificate.ts";
import { StackIcon } from "shared/ui";
import { functions } from "tools/functions";

import { appSelectors } from "../../../redux/reducers/app.ts";
import { ResponsiveButton } from "../../atoms/responsiveButton/index.tsx";
import TextFieldBig from "../../atoms/TextFieldBig";
import TooltipCustom from "../../atoms/tooltipCustom";
import ModalSubscription from "../ModalSubscription";
import ModalWindow from "../ModalWindow";
import { subscriptionHelper } from "./subscriptionHelper";
import { TeamUI } from "features/team/index.ts";
import { appConnector } from "shared/connector/singleton.ts";
import { MailboxUI } from "features/messaging";

export class TableTeams extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentId: null,
      currentIdRorEditor: null,
      currentPlan: "",
      dataPersona: {},
      editTitle: false,
      isCancelSubscriptionLoading: false,
      isContainerSelectVisible: false,
      isLeaveInviteLoading: false,
      isModalSubscriptionOpen: false,
      isResumeSubscriptionLoading: false,
      isSortAsc: null,
      isSortAscAdded: true,
      isSortAscName: null,
      loader: false,
      loading: false,
      options: [
        { label: "User", value: "user" },
        { label: "Manager", value: "manager" },
      ],
      personaId: "",
      personas: [],
      value: "",
    };
  }

  cancelTeamMemberSubscription = async (id) => {
    this.setState({ loader: true });
    this.setState({ isContainerSelectVisible: false });
    try {
      const response = await teams.cancelTeamMemberSubscription(id);
      await this.props.getPersonas();
      if (response.status === 200) {
        notificationUtils.snackById("3.29");
      }
    } catch (error) {
      notifyError(error);
    } finally {
      this.setState({ loader: false });
    }
  };

  clickOnEditAction = (row) => {
    this.setState({ editTitle: true, value: row.nickname });
  };
  customSort = () => {
    let result;
    if (this.state.isSortAsc) {
      result = this.props.personas.sort(
        (a, b) =>
          Date.parse(a?.subscription?.next_charge_date) -
          Date.parse(b?.subscription?.next_charge_date)
      );
    } else if (this.state.isSortAsc === false) {
      result = this.props.personas.sort(
        (a, b) =>
          Date.parse(b?.subscription?.next_charge_date) -
          Date.parse(a?.subscription?.next_charge_date)
      );
    } else if (this.state.isSortAscAdded) {
      result = this.props.personas.sort(
        (a, b) => Date.parse(a?.added) - Date.parse(b?.added)
      );
    } else if (this.state.isSortAscAdded === false) {
      result = this.props.personas.sort(
        (a, b) => Date.parse(b?.added) - Date.parse(a?.added)
      );
    } else if (this.state.isSortAscName) {
      result = this.props.personas
        .filter((member) => !member.pending)
        .sort((a, b) => {
          const nameA = a.nickname.toLowerCase(),
            nameB = b.nickname.toLowerCase();
          if (nameA > nameB) {
            return 1;
          }
          if (nameA < nameB) {
            return -1;
          }
          return 0;
        });
    } else if (this.state.isSortAscName === false) {
      result = this.props.personas
        .filter((member) => !member.pending)
        .sort((a, b) => {
          const nameA = a.nickname.toLowerCase(),
            nameB = b.nickname.toLowerCase();
          if (nameA > nameB) {
            return -1;
          }
          if (nameA < nameB) {
            return 1;
          }
          return 0;
        });
    } else {
      result = this.props.personas;
    }

    return result;
  };

  isActiveSelfBoughtSubscription = (row) => {
    const result =
      row.subscription.owner_id === row.id && row.subscription.is_active;
    return result;
  };

  isOwner = (row) => {
    const result = row.role === "owner";
    return result;
  };

  isTeamTrial = (currentUser) => {
    const activationDate = new Date(currentUser.subscriptionActivationDate);
    const result =
      new Date(2023, 3, 15) > activationDate &&
      new Date() < new Date(2023, 4, 15);
    return result;
  };

  isUpgradeAllowedForCurrentUser = () => {
    const currentUser = this.props.appProfile;
    const result =
      !this.props.appProfile.impersonatedPersona &&
      currentUser.subscriptionPlanId !== CONSTS.SUBSCRIPTIONS.TRIAL.ID &&
      (currentUser.teamRole === CONSTS.ROLES.Owner ||
        this.isTeamTrial(currentUser));
    return result;
  };

  onBlur = () => {
    this.onEnter();
  };

  onChangeEdit = (value) => {
    if (value.length <= CONSTS.NICK_NAME_MAX_LENGTH) {
      this.setState({ value });
    }
  };

  onEnter = async () => {
    this.setState({ loading: true });
    try {
      const response = await teams.editMemberNickName({
        id: this.state.currentIdRorEditor,
        name: this.state.value,
      });
      if (response.status === 200) {
        await appConnector.auth.refreshAccessToken();
        await this.props.getPersonas();
        notificationUtils.snackById("n3.32");
      }
    } catch (error) {
      notifyError(error);
    } finally {
      this.setState({ currentIdRorEditor: null, loading: false });
    }
  };

  openLinkedInProfile = async (row) => {
    await linkedInProfileOpener.open(row);
  };

  removeMember = async (persona) => {
    this.setState({ isDeleteInviteOpened: false });
    this.setState({ loader: true });
    try {
      const response = await teams.deleteMember(persona.id);
      if (response.status === 200) {
        await appConnector.auth.refreshAccessToken();
        await this.props.getPersonas();

        notificationUtils.snackById("n3.31");
      }
    } catch (error) {
      notifyError(error);
    } finally {
      this.setState({ loader: false });
    }
  };

  render() {
    const getDataClientWidth = (row) => {
      const lengthRow =
        row?.nickname?.length +
        (this.props.appProfile.personaId === row.id ? 3 : 0);

      return (
        (lengthRow > 13 &&
          document.documentElement.clientWidth > 1200 &&
          document.documentElement.clientWidth < 1535) ||
        (lengthRow > 22 &&
          document.documentElement.clientWidth > 1535 &&
          document.documentElement.clientWidth < 1744) ||
        (lengthRow > 30 &&
          document.documentElement.clientWidth > 1744 &&
          document.documentElement.clientWidth < 1919) ||
        (lengthRow > 35 &&
          document.documentElement.clientWidth > 1919 &&
          document.documentElement.clientWidth < 2132) ||
        (lengthRow > 43 &&
          document.documentElement.clientWidth > 2132 &&
          document.documentElement.clientWidth < 2401)
      );
    };

    const getDataClientWidthEmail = (row) => {
      return (
        (row.email.length > 19 &&
          document.documentElement.clientWidth > 1200 &&
          document.documentElement.clientWidth < 1535) ||
        (row.email.length > 28 &&
          document.documentElement.clientWidth > 1535 &&
          document.documentElement.clientWidth < 1744) ||
        (row.email.length > 36 &&
          document.documentElement.clientWidth > 1744 &&
          document.documentElement.clientWidth < 1919) ||
        (row.email.length > 41 &&
          document.documentElement.clientWidth > 1919 &&
          document.documentElement.clientWidth < 2132) ||
        (row.email.length > 49 &&
          document.documentElement.clientWidth > 2132 &&
          document.documentElement.clientWidth < 2401)
      );
    };
    return (
      <div className="table-container container-height">
        <ModalWindow
          classes="invite-modal"
          closeHandler={() => this.setState({ isModalSubscriptionOpen: false })}
          open={this.state.isModalSubscriptionOpen}
        >
          <ModalSubscription
            dataPersona={this.state.dataPersona}
            getMembers={this.props.getPersonas}
            setIsModalSubscriptionOpen={(value) =>
              this.setState({
                isModalSubscriptionOpen: value,
              })
            }
          />
        </ModalWindow>
        <TableContainer
          className={this.props.checkboxs && "table-body with-checkboxs"}
        >
          {this.state.loader && (
            <div className="table-material-loader-wrapper">
              <CircularProgress
                classes={{ colorPrimary: "material-loader" }}
                color="primary"
                size={60}
              />
            </div>
          )}
          <Table
            aria-label="a dense table"
            className={"table users"}
            size="small"
          >
            <TableHead>
              <TableRow>
                <TableCell className="name-team">
                  <div className="flex-container-accent">
                    {this.state.isSortAscName === null && (
                      <div
                        className={"container-title-text"}
                        onClick={() => {
                          this.setState({ isSortAscName: true });
                          this.setState({ isSortAsc: null });
                          this.setState({ isSortAscAdded: null });
                        }}
                      >
                        Account
                        <StackIcon
                          className={clsx(
                            "title-images",
                            this.state.isSortAscName === false &&
                              "title-images--active"
                          )}
                          icon="ascend"
                          width={18}
                        />
                      </div>
                    )}

                    {this.state.isSortAscName && (
                      <div
                        className={"container-title-text-accent"}
                        onClick={() => {
                          this.setState({ isSortAscName: false });
                          this.setState({ isSortAsc: null });
                          this.setState({ isSortAscAdded: null });
                        }}
                      >
                        Account
                        <StackIcon
                          className="title-images title-images--active"
                          icon="ascend"
                          width={18}
                        />
                      </div>
                    )}
                    {this.state.isSortAscName === false && (
                      <div
                        className={"container-title-text-accent"}
                        onClick={() => {
                          this.setState({ isSortAscName: true });
                          this.setState({ isSortAsc: null });
                          this.setState({ isSortAscAdded: null });
                        }}
                      >
                        Account
                        <StackIcon
                          className="title-images title-images--active title-images--desc"
                          icon="ascend"
                          width={18}
                        />
                      </div>
                    )}
                  </div>
                </TableCell>
                <TableCell className={"account-team"}>
                  <div className="container-title-images">Status</div>
                </TableCell>
                <TableCell className={"connection-team"}>
                  <div className="container-title-images">Role</div>
                </TableCell>
                <TableCell className={"date-accent-team"}>
                  <div className="container-title-images">Plan</div>
                </TableCell>
                <TableCell className={"date-accent-activate"}>
                  <div className="flex-container-accent">
                    {this.state.isSortAscAdded === null && (
                      <div
                        className="container-title-text"
                        onClick={() => {
                          this.setState({ isSortAscAdded: true });
                          this.setState({ isSortAscName: null });
                          this.setState({ isSortAsc: null });
                        }}
                      >
                        Added
                        <StackIcon
                          className={clsx(
                            "title-images",
                            this.state.isSortAscAdded === false &&
                              "title-images--active"
                          )}
                          icon="ascend"
                          width={18}
                        />
                      </div>
                    )}
                    {this.state.isSortAscAdded && (
                      <div
                        className="container-title-text-accent"
                        onClick={() => {
                          this.setState({ isSortAscAdded: false });
                          this.setState({ isSortAscName: null });
                          this.setState({ isSortAsc: null });
                        }}
                      >
                        Added
                        <StackIcon
                          className="title-images title-images--active"
                          icon="ascend"
                          width={18}
                        />
                      </div>
                    )}
                    {this.state.isSortAscAdded === false && (
                      <div
                        className="container-title-text-accent"
                        onClick={() => {
                          this.setState({ isSortAscAdded: true });
                          this.setState({ isSortAscName: null });
                          this.setState({ isSortAsc: null });
                        }}
                      >
                        Added
                        <StackIcon
                          className="title-images title-images--active title-images--desc"
                          icon="ascend"
                          width={18}
                        />
                      </div>
                    )}
                  </div>
                </TableCell>
                <TableCell className={"date-accent-charge"}>
                  <div className="flex-container-accent">
                    {this.state.isSortAsc === null && (
                      <div
                        className="container-title-text"
                        onClick={() => {
                          this.setState({ isSortAsc: true });
                          this.setState({ isSortAscAdded: null });
                          this.setState({ isSortAscName: null });
                        }}
                      >
                        <p className="team-title"> Next Charge</p>

                        <StackIcon
                          className={clsx(
                            "title-images",
                            this.state.isSortAsc === false &&
                              "title-images--active"
                          )}
                          icon="ascend"
                          width={18}
                        />
                      </div>
                    )}
                    {this.state.isSortAsc && (
                      <div
                        className="container-title-text-accent"
                        onClick={() => {
                          this.setState({ isSortAsc: false });
                          this.setState({ isSortAscAdded: null });
                          this.setState({ isSortAscName: null });
                        }}
                      >
                        <p className="team-title"> Next Charge</p>
                        <StackIcon
                          className="title-images title-images--active"
                          icon="ascend"
                          width={18}
                        />
                      </div>
                    )}
                    {this.state.isSortAsc === false && (
                      <div
                        className="container-title-text-accent"
                        onClick={() => {
                          this.setState({ isSortAsc: true });
                          this.setState({ isSortAscAdded: null });
                          this.setState({ isSortAscName: null });
                        }}
                      >
                        <p className="team-title"> Next Charge</p>
                        <StackIcon
                          className="title-images title-images--active title-images--desc"
                          icon="ascend"
                          width={18}
                        />
                      </div>
                    )}
                  </div>
                </TableCell>
                {this.showSigninColumn() && (
                  <TableCell className={"sign-in-team"}>
                    <div className="container-title-images">Actions</div>
                  </TableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody className="app-scroll" ref={this.wrapper}>
              {this.customSort()
                .filter((el) => !el.pending)
                .map((row, index) => (
                  <TableRow className="row" key={row.id}>
                    <TableCell className="name-team">
                      <div className="name-container">
                        <img
                          alt="avatar"
                          className="avatar"
                          src={row.avatar ? row.avatar : avatarSvg}
                        />
                        <div className="ellipsis">
                          <div className="flex-wrapper-team-accent">
                            {(row.entityId || row.publicIdentifier) && (
                              <a
                                href="/#"
                                onClick={async (e) => {
                                  e.preventDefault();
                                  await this.openLinkedInProfile(row);
                                }}
                                rel="noopener noreferrer"
                                target="_blank"
                              >
                                <TooltipCustom
                                  arrow={true}
                                  title="Open LinkedIn profile"
                                >
                                  <img
                                    alt="link svg"
                                    className="link-img-accent "
                                    src={linkSvgGold}
                                  />
                                </TooltipCustom>
                              </a>
                            )}
                            <div className="text-box-wrapper">
                              {this.state.currentIdRorEditor !== row.id ? (
                                <div className="edit-title ">
                                  <div
                                    className={
                                      getDataClientWidth(row)
                                        ? "text-box-wrapper-hover "
                                        : "text-box-wrapper"
                                    }
                                  >
                                    <TooltipCustom
                                      arrow={true}
                                      title={
                                        getDataClientWidth(row)
                                          ? row.nickname
                                          : ""
                                      }
                                    >
                                      <div className="text-page first-name semi-bold ellipsis">
                                        {row.nickname}
                                      </div>
                                    </TooltipCustom>
                                  </div>

                                  {this.props.appProfile.personaId === row.id &&
                                    "(you)"}

                                  <MailboxUI.UnreadCountView
                                    count={
                                      row.linkedin_profile
                                        .unread_conversations_counters.inbox
                                    }
                                  />
                                  <button
                                    className="btn-edit size-btn-edit"
                                    onClick={() => {
                                      this.clickOnEditAction(row);
                                      this.setState({
                                        currentIdRorEditor: row.id,
                                      });
                                    }}
                                  ></button>
                                </div>
                              ) : (
                                <TextFieldBig
                                  autoFocus
                                  endAdornment={
                                    this.state.loading ? (
                                      <img alt="loading" src={iconLoading} />
                                    ) : (
                                      ""
                                    )
                                  }
                                  fullWidth
                                  onBlur={this.onBlur}
                                  onChange={(e) =>
                                    this.onChangeEdit(e.target.value)
                                  }
                                  onEnter={this.onEnter}
                                  value={this.state.value}
                                />
                              )}
                            </div>
                          </div>
                          <div
                            className={
                              getDataClientWidthEmail(row)
                                ? "text-box-wrapper-hover"
                                : "text-box-wrapper"
                            }
                          >
                            <TooltipCustom
                              arrow
                              title={
                                getDataClientWidthEmail(row) ? row.email : ""
                              }
                            >
                              <p className={"email-team ellipsis"}>
                                {row.email}
                              </p>
                            </TooltipCustom>
                          </div>
                        </div>
                      </div>
                    </TableCell>

                    <TableCell className="account-team">
                      <div className="containerBilling__flex-color-container">
                        {subscriptionHelper
                          .getStatusTags(row.subscription)
                          .map((status) => (
                            <p className={status.style} key={status.text}>
                              {status.text}
                            </p>
                          ))}
                      </div>
                    </TableCell>
                    <TableCell className="connection-team">
                      <p className={"left-list-text-accent-role"}>{row.role}</p>
                    </TableCell>
                    <TableCell className="date-accent-team">
                      <div className="flex-wrapper-team">
                        <p className={"left-list-text-accent"}>
                          {row.subscription.plan_id.toUpperCase()}
                        </p>
                        {this.isUpgradeAllowedForCurrentUser() &&
                          !this.isOwner(row) &&
                          !this.isActiveSelfBoughtSubscription(row) && (
                            <div className="flex-container-accent">
                              <ResponsiveButton
                                className={"link-upgrade"}
                                disabled={false}
                                isLoading={false}
                                onClick={() => {
                                  this.setState({
                                    isModalSubscriptionOpen: true,
                                  });
                                  this.setState({
                                    dataPersona: row,
                                  });
                                }}
                              >
                                {"Upgrade"}
                              </ResponsiveButton>
                              <img alt="arrow" src={arrow} />
                            </div>
                          )}
                        {this.isUpgradeAllowedForCurrentUser() &&
                          !this.isOwner(row) &&
                          this.isActiveSelfBoughtSubscription(row) && (
                            <p className="link-upgrade-accent">Self-Paid</p>
                          )}
                      </div>
                    </TableCell>
                    <TableCell className="date-accent-activate">
                      <p className={"left-list-text-accent"}>
                        {functions.parseDateToDMY(row.added, "/")}
                      </p>
                    </TableCell>
                    <TableCell className="date-accent-charge">
                      {subscriptionHelper.showNextCharge(row.subscription) && (
                        <>
                          <p className={"left-list-text-accent"}>
                            {functions.parseDateToDMY(
                              row.subscription.next_charge_date,
                              "/"
                            )}
                          </p>
                          {subscriptionHelper.showNextChargePrice(
                            row.subscription
                          ) && (
                            <p className={"left-list-text-accent"}>
                              (${row.subscription.actual_price} USD)
                            </p>
                          )}
                        </>
                      )}
                    </TableCell>
                    {this.showSigninColumn(row) && (
                      <TableCell className="sign-in-team">
                        <div className="dots-container">
                          <TeamUI.SignInMember id={row.id} />

                          {this.showDots(row) && (
                            <>
                              {!this.isOwner(row) && (
                                <img
                                  alt="threeDots"
                                  className="img-threeDots"
                                  onClick={() => {
                                    this.setState({
                                      currentId: row.id,
                                      isContainerSelectVisible:
                                        !this.state.isContainerSelectVisible,
                                    });
                                  }}
                                  src={threeDots}
                                />
                              )}
                              {this.state.isContainerSelectVisible &&
                                row.id === this.state.currentId && (
                                  <>
                                    <div
                                      className="backdrop-team"
                                      onClick={() => {
                                        this.setState({
                                          isContainerSelectVisible: false,
                                        });
                                      }}
                                    ></div>
                                    <div className="container-select">
                                      {this.showRemoveMember(row) && (
                                        <ResponsiveButton
                                          className={"select-button"}
                                          disabled={false}
                                          isLoading={false}
                                          onClick={() => {
                                            this.setState({
                                              selectedPersona: row,
                                            });
                                            this.setState({
                                              isDeleteInviteOpened: true,
                                            });
                                            this.setState({
                                              isContainerSelectVisible: false,
                                            });
                                          }}
                                        >
                                          <img
                                            alt="deleteInviteSvg"
                                            height="15"
                                            src={deleteInviteSvg}
                                            width="12"
                                          />
                                          Remove member
                                        </ResponsiveButton>
                                      )}
                                      {this.showCancelSubscription(row) && (
                                        <ResponsiveButton
                                          className={"select-button"}
                                          disabled={false}
                                          isLoading={false}
                                          onClick={() => {
                                            this.cancelTeamMemberSubscription(
                                              row.id
                                            );
                                          }}
                                        >
                                          <img alt="iconPause" src={iconStop} />
                                          Cancel subscription
                                        </ResponsiveButton>
                                      )}
                                      {this.showResumeSubscription(row) && (
                                        <ResponsiveButton
                                          className={"select-button"}
                                          disabled={false}
                                          isLoading={false}
                                          onClick={() => {
                                            this.resumeTeamMemberSubscription(
                                              row.id
                                            );
                                          }}
                                        >
                                          Resume subscription
                                        </ResponsiveButton>
                                      )}
                                    </div>
                                  </>
                                )}
                            </>
                          )}
                        </div>
                      </TableCell>
                    )}
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>
        <ModalWindow
          closeHandler={() => this.setState({ isDeleteInviteOpened: false })}
          closeText="No"
          confirmHandler={() => this.removeMember(this.state.selectedPersona)}
          confirmText="Yes"
          content={CONSTS.confirmationDialogs["c1.14"].content
            .replace("{nickname}", this.state.selectedPersona?.nickname ?? "")
            .replace("{email}", this.state.selectedPersona?.email ?? "")}
          open={this.state.isDeleteInviteOpened}
          title={CONSTS.confirmationDialogs["c1.14"].title}
        />
      </div>
    );
  }

  resumeTeamMemberSubscription = async (id) => {
    this.setState({ loader: true });
    this.setState({ isContainerSelectVisible: false });
    try {
      const response = await teams.resumeTeamMemberSubscription(id);
      await this.props.getPersonas();
      if (response.status === 200) {
        notificationUtils.snackById("n3.30");
      }
    } catch (error) {
      notifyError(error);
    } finally {
      this.setState({ loader: false });
    }
  };

  showCancelSubscription = (row) => {
    const result =
      this.isUpgradeAllowedForCurrentUser() &&
      !this.isActiveSelfBoughtSubscription(row) &&
      row.subscription.is_active &&
      row.subscription.state !== CONSTS.SUBSCRIPTIONS.STATE.CANCELED &&
      row.subscription.plan_id !== CONSTS.SUBSCRIPTIONS.TRIAL.ID;
    return result;
  };

  showDots = (row) => {
    const result =
      this.showRemoveMember(row) ||
      this.showCancelSubscription(row) ||
      this.showResumeSubscription(row);
    return result;
  };

  showRemoveMember = (row) => {
    const result =
      !row.subscription.is_active ||
      row.subscription.owner_id === row.id ||
      !row.subscription.owner_id;
    return result;
  };

  showResumeSubscription = (row) => {
    const result =
      this.isUpgradeAllowedForCurrentUser() &&
      !this.isActiveSelfBoughtSubscription(row) &&
      row.subscription.is_active &&
      row.subscription.state === CONSTS.SUBSCRIPTIONS.STATE.CANCELED &&
      row.subscription.plan_id !== CONSTS.SUBSCRIPTIONS.TRIAL.ID;
    return result;
  };
  showSigninColumn = () => {
    const result = !this.props.appProfile.impersonatedPersona;
    return result;
  };
}

const mapStateToProps = function (state) {
  return {
    activity: state.activity,
    appProfile: appSelectors.appProfile(state),
    pageContentLoader: state.app.pageContentLoader,
    subscription: state.app.subscription,
  };
};
export default connect(mapStateToProps)(TableTeams);
